export default __webpack_public_path__ + "static/media/kelohuvila-logo.7a037d04.png";